import { sessionStorageAvailable } from "./shop"

export const parseQueryString = (searchString: string): Record<any, string> => {
  const str = searchString
  const objURL: Record<any, string> = {}

  str.replace(
    new RegExp("([^?=&]+)(=([^&]*))?", "g"),
    ($0, $1, $2, $3): any => {
      objURL[$1] = $3
    }
  )

  return objURL
}

export const withPrefix = (path: string): string => {
  if (
    typeof process.env.GATSBY_PREFIX_PATH === "string" &&
    path.substring(0, process.env.GATSBY_PREFIX_PATH.length) ===
      `${process.env.GATSBY_PREFIX_PATH}`
  ) {
    return path
  } else {
    return `${process.env.GATSBY_PREFIX_PATH || ""}${path}`
  }
}

export const appendQueryParams = (path: string, params: string): string => {
  const newParams = new URLSearchParams(params)
  return `${path}?${newParams}`
}

export const storeQueryString = (searchString: string) => {
  if (searchString && sessionStorageAvailable()) {
    sessionStorage.setItem("queryStringParams", searchString)
  }
}

export const fetchQueryString = () => {
  if (sessionStorageAvailable()) {
    return sessionStorage.getItem("queryStringParams")
  } else {
    return null
  }
}

export const filterQueryString = (searchString: string, filter: string[]) => {
  return searchString
    .match(new RegExp(`(${filter.join("|")})=([^&]*)`, "gi"))
    ?.join("&")
}

export const getSignupQueryString = () => {
  const storedQueryString = fetchQueryString()
  const allowedParams =
    process.env.GATSBY_SHOP_SIGNUP_ALLOWED_QUERY_PARAMS?.split(",")

  if (!storedQueryString || !allowedParams) return ""

  return new URLSearchParams(
    filterQueryString(storedQueryString, allowedParams)
  ).toString()
}
